<template>
    <div class="pb-5 auto-website" style="height: initial !important">
        <template v-if="loading || is_publishing">
            <LoaderComponent />
            <div v-if="is_publishing" class="text-center">
                <h5>Votre site est en cours de déploiement. Cette opération peut durer plusieurs minutes.</h5>
            </div>
        </template>
        <div class="ms-2 alert alert-danger" v-else-if="!website_enabled">
            Vous devez d'abord configurer votre site avant de pouvoir le personnaliser
        </div>
        <div class="ms-2 alert alert-danger" v-else-if="error">{{ error }}</div>
        <template v-else>
            <tab-bar direction="horizontal" side="top" :entries="tabBarEntries" />
            <router-view class="mt-5" v-bind="{ website_settings, website_enabled }" @fetch-data="fetchData" />
        </template>
    </div>
</template>

<script>
import LoaderComponent from "../../components/LoaderComponent";
import TabBar from "../../components/tabBar/TabBar";

export default {
    data() {
        return {
            loading: 0,
            error: null,
            errors: {},
            website_settings: null,
            tabBarEntries: [
                {
                    to: {
                        name: "website.restaurants.customization.content",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: "Contenu",
                    exactUrlMatching: false,
                },
                {
                    to: {
                        name: "website.restaurants.customization.modals",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: "Pop-up",
                    exactUrlMatching: false,
                },
                {
                    to: {
                        name: "website.restaurants.customization.connected_modules",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: "Modules connectés",
                    exactUrlMatching: false,
                },
                {
                    to: {
                        name: "website.restaurants.customization.external_links",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: "Liens externes",
                    exactUrlMatching: false,
                },
            ],
        };
    },
    computed: {
        is_publishing() {
            return this.$store.getters["websites/is_publishing"];
        },
        restaurant_id() {
            return this.$route.params.restaurant_id;
        },
        website_enabled() {
            return this.$store.getters["websites/website_enabled"];
        },
    },
    methods: {
        fetchData() {
            this.loading++;
            this.error = null;
            this.website_settings = null;

            this.$store
                .dispatch("websites/getWebsiteSettings", { restaurant_id: this.restaurant_id })
                .then((response) => {
                    this.loading--;
                    this.website_settings = response.data.website_settings;
                    if (this.website_settings) {
                        if (this.website_settings.menus.length == 0)
                            for (let i = 1; i <= 3; i++) this.website_settings.menus.push(this.initNewMenu(i));
                        this.website_settings.show_address = this.website_settings.show_address ? false : true;
                    }
                })
                .catch((error) => {
                    this.loading--;
                    this.error = this.getErrorMsgFromErrorResponse(error);
                });
        },
        initNewMenu(nb) {
            return {
                id: null,
                nb: nb,
                title: "",
                price_in_cent: null,
                content: "",
            };
        },
    },
    watch: {
        website_settings: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal && oldVal) this.$store.dispatch("websites/setUnsavedChanges", true);
                this.$store.dispatch("websites/setAllSettings", newVal);
            },
        },
        website_enabled(newVal) {
            if (!newVal) this.$router.push({ name: "website.restaurants.settings" });
        },
    },
    components: {
        LoaderComponent,
        TabBar,
    },
    created() {
        this.fetchData();
    },
};
</script>
